var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOpenInNew = function SvgOpenInNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "open_in_new_svg__a",
    width: 19,
    height: 19,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h19v19H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#open_in_new_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M4.2 16.23q-.6-.001-1.015-.416a1.38 1.38 0 0 1-.415-1.016V4.202q0-.6.415-1.015a1.38 1.38 0 0 1 1.016-.416h4.4q.252 0 .423.17t.17.424-.17.423a.57.57 0 0 1-.424.17H4.2a.23.23 0 0 0-.167.077.23.23 0 0 0-.076.167v10.596q0 .092.076.168t.168.076h10.596a.23.23 0 0 0 .167-.076.23.23 0 0 0 .076-.168v-4.4q0-.253.171-.423a.57.57 0 0 1 .423-.17q.254 0 .423.17.17.171.17.423v4.4q0 .6-.415 1.016a1.38 1.38 0 0 1-1.015.415zM15.04 4.792l-6.93 6.93a.57.57 0 0 1-.413.168.56.56 0 0 1-.421-.168.57.57 0 0 1-.172-.417q0-.246.172-.418l6.93-6.93h-2.53a.57.57 0 0 1-.423-.17.57.57 0 0 1-.171-.423q0-.253.17-.424a.57.57 0 0 1 .424-.17h3.836q.306 0 .511.205a.7.7 0 0 1 .205.51v3.837q0 .253-.17.423a.57.57 0 0 1-.424.17.57.57 0 0 1-.423-.17.57.57 0 0 1-.17-.423z"
  }))));
};
export default SvgOpenInNew;